<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Admitted Student Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <center><v-btn class="mt-6 button" @click="getAdmittedReport" :loading="fetch_btn_load">Fetch</v-btn></center>
            <v-card-text>
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-switch color="#0F2027" v-model="all_toggle" label="Toggle All"></v-switch>
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-switch color="#0F2027" v-model="field.admission_form_no" label="Admission Form No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.registration_number" label="Registration Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.rollno" label="Roll No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.grno" label="GRNo"></v-switch>
                    <v-switch color="#0F2027" v-model="field.quota" label="Quota"></v-switch>
                    <v-switch color="#0F2027" v-model="field.saralid" label="Saral-id"></v-switch>
                    <v-switch color="#0F2027" v-model="field.admissionyear" label="Admission Year"></v-switch>
                    <v-switch color="#0F2027" v-model="field.admission_date" label="Admission Date"></v-switch>
                    <v-switch color="#0F2027" v-model="field.admissionstatus" label="Admission Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.firstname" label="First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.middlename" label="Middle Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.lastname" label="Last Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.fullname" label="Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_full_name" label="Father Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_first_name" label="Mother First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth" label="DoB"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth_in_words" label="Date Of Birth In Words"></v-switch>
                    <v-switch color="#0F2027" v-model="field.family_income" label="Family Income"></v-switch>
                    <v-switch color="#0F2027" v-model="field.division" label="Division"></v-switch>
                    <v-switch color="#0F2027" v-model="field.standard" label="Standard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.currentstandard" label="Current Standard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.house" label="House"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bloodgroup" label="Blood Group"></v-switch>
                    <v-switch color="#0F2027" v-model="field.category" label="Category"></v-switch>
                    <v-switch color="#0F2027" v-model="field.religion" label="Religion"></v-switch>
                    <v-switch color="#0F2027" v-model="field.cast" label="Caste"></v-switch>
                    <v-switch color="#0F2027" v-model="field.aadhar_no" label="Aadhar No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.domacile" label="Domicile"></v-switch>
                    <v-switch color="#0F2027" v-model="field.prizes" label="Prizes"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previous_school_name" label="Previous School Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previousschoolpassingstandard" label="Previous School Passing Standard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previousschoollastyear" label="Previous School Last Year"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previousschoolschoolboard" label="Previous School SchoolBoard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mobile_no" label="Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.alternate_mobile_no" label="Alternate Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.telephone_no" label="Telephone No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.primary_contact_number" label="Primary No.(communication purpose)"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_contact_number" label="Father's Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_contact_number" label="Mother's Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_number" label="Emergency Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_name" label="Emergency Contact Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_address" label="Emergency Contact Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_place" label="Birth Place"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_address" label="Birth Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.physicallyhandicapped_details" label="Physically Handicapped Details"></v-switch>
                    <v-switch color="#0F2027" v-model="field.isphysicallyhandicapped" label="Is physically Handicapped"></v-switch>
                    <!-- <v-switch color="#0F2027" v-model="field.highest_qualification" label="Highest Qualification"></v-switch> -->
                    <v-switch color="#0F2027" v-model="field.personal_email" label="Personal Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.institute_email" label="Institute Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.home_distance_in_km_from_school" label="Home Distance In Km From School"></v-switch>
                    <v-switch color="#0F2027" v-model="field.gender" label="Gender"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birthcountry" label="Birth Country"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mothertoungue" label="Mother Tongue"></v-switch>
                    <v-switch color="#0F2027" v-model="field.localaddress" label="Local Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.permanentaddress" label="Permanent Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.photo" label="Student Photo Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_email" label="Father's Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_email" label="Mother's Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.sibling_details" label="Siblings Details"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_mark" label="Birth Mark"></v-switch>
                    <v-switch color="#0F2027" v-model="field.medical_condition" label="Medical Condition"></v-switch>
                    <v-switch color="#0F2027" v-model="field.allergy" label="Allergy"></v-switch>
                </v-row>
            </v-card-text>
        </v-card>
        <br />
        <!-- api-1 ends -->

        <div v-if="field_list!='' && header_list!=''">
            <v-card class="box">

                <!-- <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="exs_loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                 -->
                  <v-btn rounded  color="success" outlined @click="fnExcelReport('my-table-id','admittedstudentreport');" ><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                
                <v-card-text>
                    <div id="my-table-id">
                <div class="scroll">
              <v-simple-table v-if="header_list!=''"  dense class="elevation-1" fixed-header height="500px">
                        <thead>
                            <tr>
                                <th v-for="(hl, index) in header_list" :key="index">
                                    {{ hl.text }}
                                </th>
                                <th v-if="td_view">Photo Preview</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(fl, index) in field_list" :key="index">
                                <td v-for="(hl, index1) in header_list" :key="index1">
                                    {{fl[hl.value]}}
                                </td>
                                <td v-if="td_view">
                                    <img v-if="fl.photo!='NA'" :src="fl.photo" width="50px" height="50px" />
                                    <span v-else>NA</span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <th v-for="(hl, index) in header_list" :key="index">
                                {{ hl.text }}
                            </th>
                            <th v-if="td_view">Photo Preview</th>
                        </tfoot>
                   </v-simple-table>
                </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            //1
            overlay: false,
            search: "",
            ay_std_data: null,
            fetch_btn_load: false,
            current_academic_year: "",
            std: "",
            status: "",
            exs_loader: false,
            //fields
            field: {
                father_email: false,
                mother_email: false,
                sibling_details: false,
                birth_mark: false,
                medical_condition: false,
                allergy: false,
                division: false,
                admission_form_no: false,
                firstname: false,
                middlename: false,
                lastname: false,
                fullname: false,
                date_of_birth: false,
                standard: false,
                bloodgroup: false,
                category: false,
                religion: false,
                aadhar_no: false,
                mobile_no: false,
                alternate_mobile_no: false,
                telephone_no: false,
                emergency_contact_name: false,
                emergency_contact_address: false,
                emergency_contact_number: false,
                mother_contact_number: false,
                father_contact_number: false,
                primary_contact_number: false,
                birth_place: false,
                birth_address: false,
                father_full_name: false,
                mother_first_name: false,
                physicallyhandicapped_details: false,
                isphysicallyhandicapped: false,
                date_of_birth_in_words: false,
                highest_qualification: false,
                personal_email: false,
                institute_email: false,
                home_distance_in_km_from_school: false,
                gender: false,
                birthcountry: false,
                mothertoungue: false,
                // current_academic_year: false,
                admissionyear: false,
                previous_school_name: false,
                prizes: false,
                rollno: false,
                family_income: false,
                admission_date: false,
                registration_number: false,
                admissionstatus: false,
                domacile: false,
                cast: false,
                previousschoolpassingstandard: false,
                previousschoollastyear: false,
                previousschoolschoolboard: false,
                currentstandard: false,

                quota: false,
                saralid: false,
                grno: false,

                // std: false,
                // status: false,
                dataTable: null,
                localaddress: false,
                permanentaddress: false,
                photo: false,
                house: false,
            },
            all_toggle: false,
            td_view: false,
            //2
            header_list: [],
            field_list: [],
            xls_header: [],
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            status_list: [],
            snackbar: false,
            snackbar_msg: "",
            color: "",
        }),
        watch: {
            all_toggle() {
                // console.log(this.all_toggle);
                var keys = Object.keys(this.field);
                // console.log("keys:"+this.field[keys[0]])
                for (let i = 0; i < keys.length; i++) this.field[keys[i]] = this.all_toggle;
            },
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
                tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';
                tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
                tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $('#' + id).clone();
                exportTable.find('input').each(function (index, elem) { $(elem).remove(); });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + '</table></body></html>';
                var fileName = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

                //Save the file
                // var blob = new Blob([tab_text], { type: "application/vnd.ms-excel;charset=utf-8" })
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
                },
             ExportToExcel(){
                    this.exs_loader = true
            var htmltable= document.getElementById('my-table-id');
            var html = htmltable.outerHTML;
            window.open('data:application/vnd.ms-excel,' + encodeURIComponent(html));
             this.exs_loader = false
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getAdmittedReport() {
                if (this.field.photo == true) {
                    this.td_view = true;
                } else {
                    this.td_view = false;
                }
                this.field_list = null;
                this.fetch_btn_load = true;
                let data = {
                    // current_academic_year_id:ay ,
                    // standard_obj:this.sel_std_data,
                    // division_off_id: div,
                    status: this.status,
                    field: this.field,
                };
                axios
                    .post("/admissionReport/getLearnerDataWithoutLD", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.field_list = res.data.field_list;
                            this.header_list = res.data.header_list;
                            this.xls_header = res.data.xls_header;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.fetch_btn_load = false;
                        // this.dataTable = $("#admitted-student-report").DataTable({
                        //     colReorder: true,
                        //     dom: "Bfrtip",
                        //     buttons: ["csvHtml5", "excelHtml5", "print"],
                        // });
                    });
            },
            get_ay_std() {
                // this.overlay = true;
                // axios
                //     .post("/CommonAPI/get_ay_std_div_for_report")
                //     .then((res) => {
                //         this.overlay = false;
                //             this.ay_std_div_list = res.data.data;
                //             this.sel_ay_data = res.data.curr_ay;
                //             this.status_list = res.data.status_list;
                //     })
                //     .catch((error) => {
                //         this.overlay = false;
                //         window.console.log(error);
                //     })
                //     .finally(() => {
                //         this.overlay = false;
                //         //close loader
                //     });
            },
        },
        mounted() {
            // this.get_ay_std();
        },
    };
</script>
<style>
    .dt-button {
        font-size: 14px;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
